import { render, staticRenderFns } from "./IssueEds.vue?vue&type=template&id=4311c10e&"
import script from "./IssueEds.vue?vue&type=script&lang=js&"
export * from "./IssueEds.vue?vue&type=script&lang=js&"
import style0 from "./IssueEds.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports